import React, { RefObject } from 'react';
import useTranslation from '../hooks/useTranslation';
import Loading, { LoadingBall } from '@ingka/loading';
import styled from 'styled-components';
import { SparePart } from '../interfaces/Item';
import { AspectRatioImage } from './AspectRatioImage';
import HighlightText from './HighlightText';
import ProductParts from '../components/ProductParts/ProductParts';

interface ListItemProps {
  items: SparePart[];
  onClickItem: (item: SparePart) => void;
  onChangSearch?: Function;
  highlight: string;
  setSearch?: Function;
}
const Image = styled.div`
  width: 75px;
  height: auto;
  padding-right: 8px;
  min-width: auto;
  margin-inline-end: 10px;
`;
const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-all;
`;
const StyledHighlightText = styled(HighlightText)``;
const SearchResultItem = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  overflow: hidden;
  height: 100px;
  border: 0;
  width: 100%;
  background: transparent;
  padding: 0;
  margin: 0;
  border-radius: 4px;

  :hover,
  :focus-visible {
    ${StyledHighlightText} {
      text-decoration: underline;
    }
  }

  :focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
`;

const SearchResultListWrapper = styled.li``;
export const ListItems: React.FC<ListItemProps> = ({
  items,
  highlight,
  ...rest
}): JSX.Element => {
  const result = items.map((item) => {
    const { id, imageSrc } = item;
    const { onClickItem } = rest;
    return (
      <SearchResultListWrapper key={item.id} className="item">
        <SearchResultItem
          key={id}
          onClick={(): void => onClickItem(item)}
          {...rest}
        >
          <Image>
            <AspectRatioImage src={imageSrc} alt="" />
          </Image>
          <FlexContainer>
            <StyledHighlightText text={`${id}`} highlight={highlight} />
          </FlexContainer>
        </SearchResultItem>
      </SearchResultListWrapper>
    );
  });

  return <>{result}</>;
};

interface SearchForItemsProps {
  search: string;
  onClickItem: (item: SparePart | undefined) => void;
  setSearch?: Function;
  loading: boolean;
  items: SparePart[];
  componentData: SparePart[];
  itemFamily: SparePart[];
  onChangeSearch?: Function;
  onSetSelectedItem?: Function;
  refInput?: RefObject<HTMLElement>;
}

export const DisplaySearchItems: React.FC<SearchForItemsProps> = ({
  search,
  loading,
  items,
  componentData,
  ...rest
}): JSX.Element | null => {
  const { t } = useTranslation();
  if (loading) {
    return (
      <Loading
        text={t('spareParts.search.searchingFor', {
          search,
        })}
      >
        <LoadingBall />
      </Loading>
    );
  }
  if (!items.length && !componentData.length) {
    return null;
  }
  return (
    <>
      <ListItems items={items} highlight={search} {...rest} />
      {search.length >= 8 && items.length > 0 && <hr />}
      {search.length >= 8 ? (
        componentData.map((articleItem: any, index: number) => (
          <React.Fragment key={index}>
            <ProductParts articleItem={articleItem} />
          </React.Fragment>
        ))
      ) : (
        <></>
      )}
    </>
  );
};
